import React from "react";
import "./style.scss";
import Table from "../../Table";
import { formatDateInTimeZone, FormatUSD } from "../../../utils/helpers/string";
import { ReactComponent as TradingChart } from "../../../assets/icons/chart.svg";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setTradeDetails } from "../../../utils/store/reducers/accountMetricsSlice";

function CloseTrades({ data = [] }) {
  const { account_name, email } = useSelector(
    (state) => state.accountMetrics.data
  );
  const dispatch = useDispatch();

  const alphaticksColumns = [
    {
      Header: "Account Name",
      accessor: "",
      Cell: ({ value }) => <div>{account_name}</div>,
    },
    {
      Header: "Username",
      accessor: "",
      Cell: ({ value }) => <div>{email}</div>,
    },
    {
      Header: "Trade Day",
      accessor: "tradeDay",
      Cell: ({ value }) => <div>{formatDateInTimeZone(value)}</div>,
    },

    { Header: "Symbol", accessor: "contractGroupId" },
    { Header: "Symbol Name", accessor: "contractName" },
    { Header: "Volume", accessor: "lots" },

    {
      Header: "Open Time",
      accessor: "createdAt",
      Cell: ({ value }) => <div>{formatDateInTimeZone(value)}</div>,
    },
    {
      Header: "Close Time",
      accessor: "enteredAt",
      Cell: ({ value }) => <div>{formatDateInTimeZone(value)}</div>,
    },

    { Header: "Trade Duration", accessor: "tradeDuration" },
    { Header: "Entry Price", accessor: "entryPrice" },
    { Header: "Exit Price", accessor: "exitPrice" },

    { Header: "Fees", accessor: "fees" },

    {
      Header: "Chart",
      accessor: "",
      Cell: ({ row }) => (
        <Link
          to="/trade-details"
          target="_blank"
          style={{ cursor: "pointer" }}
          onClick={() => {
            dispatch(setTradeDetails(row?.original));
          }}
        >
          <TradingChart />
        </Link>
      ),
    },

    {
      Header: "Profit/Loss",
      accessor: "pnl",
      Cell: ({ value }) => (
        <span className={value < 0 ? "negative-profit" : "positive-profit"}>
          {value < 0 ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M13.0222 6.02222C13.2861 6.28609 13.2861 6.71391 13.0222 6.97778L7 13L0.97778 6.97778C0.71391 6.71391 0.713909 6.28609 0.97778 6.02222C1.24165 5.75835 1.66947 5.75835 1.93334 6.02222L7 11.0889L12.0667 6.02222C12.3305 5.75835 12.7583 5.75835 13.0222 6.02222Z"
                fill="#FF4343"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M13.0222 12.5227C13.2861 12.2588 13.2861 11.831 13.0222 11.5671L7 5.54492L0.97778 11.5671C0.71391 11.831 0.713909 12.2588 0.97778 12.5227C1.24165 12.7866 1.66947 12.7866 1.93334 12.5227L7 7.45606L12.0667 12.5227C12.3305 12.7866 12.7583 12.7866 13.0222 12.5227Z"
                fill="#7AD67A"
              />
            </svg>
          )}
          ${Math.abs(value)}
        </span>
      ),
    },
  ];

  const tradovateColumns = [
    // { Header: "ID", accessor: "id" },
    {
      Header: "Account ID",
      accessor: "",
      Cell: ({ value }) => <div>{account_name}</div>,
    },
    {
      Header: "Username",
      accessor: "",
      Cell: ({ value }) => <div>{email}</div>,
    },
    {
      Header: "Trade Day",
      accessor: "trade_date",
      Cell: ({ value }) => <div>{formatDateInTimeZone(value)}</div>,
    },
    {
      Header: "Symbol",
      accessor: "symbol",
      Cell: ({ value }) => <div>{value ? value : "N/A"}</div>,
    },
    { Header: "Volume", accessor: "volume" },

    {
      Header: "Open Time",
      accessor: "open_time",
      Cell: ({ value }) => <div>{formatDateInTimeZone(value)}</div>,
    },
    {
      Header: "Close Time",
      accessor: "close_time",
      Cell: ({ value }) => <div>{formatDateInTimeZone(value)}</div>,
    },

    { Header: "Trade Duration", accessor: "trade_duration" },

    {
      Header: "Open Price",
      accessor: "open_price",
      Cell: ({ value }) => <div>{FormatUSD(value)}</div>,
    },
    {
      Header: "Close Price",
      accessor: "close_price",
      Cell: ({ value }) => <div>{FormatUSD(value)}</div>,
    },
    {
      Header: "Fees",
      accessor: "fee",
      Cell: ({ value }) => <div>{FormatUSD(value)}</div>,
    },

    {
      Header: "PnL",
      accessor: "pnl",
      Cell: ({ value }) => (
        <div className={value < 0 ? "negative-profit" : "positive-profit"}>
          {FormatUSD(value)}
        </div>
      ),
    },

    {
      Header: "Chart",
      accessor: "",
      Cell: ({ row }) => (
        <Link
          to="/trade-details"
          target="_blank"
          style={{ cursor: "pointer" }}
          onClick={() => {
            dispatch(setTradeDetails(row?.original));
          }}
        >
          <TradingChart />
        </Link>
      ),
    },
    { Header: "Position", accessor: "position" },

    {
      Header: "Commission",
      accessor: "commission",
      Cell: ({ value }) => <div>{FormatUSD(value)}</div>,
    },

    { Header: "In Action", accessor: "in_action" },
    { Header: "Out Action", accessor: "out_action" },
  ];

  return (
    <div className="close-trades">
      <p className="timezone-asterisk-note">
        * All timestamps are shown in America/Chicago (CT).
      </p>
      <div className="db_table_container">
        <Table
          columns={
            data?.trading_platform === 1 ? alphaticksColumns : tradovateColumns
          }
          data={data?.account_metrics?.data || []}
          variant={2}
        />
        {/* <Route
            path="/trade-details"
            element={<TradeDetailsPage tradeData={openChart} />}
          /> */}
      </div>
    </div>
  );
}

export default CloseTrades;
